/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IpitFrontEndSettings } from '../../models/ipit-front-end-settings';

export interface GetSettings$Json$Params {
}

export function getSettings$Json(http: HttpClient, rootUrl: string, params?: GetSettings$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<IpitFrontEndSettings>> {
  const rb = new RequestBuilder(rootUrl, getSettings$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IpitFrontEndSettings>;
    })
  );
}

getSettings$Json.PATH = '/FrontEndSettings';
